/* 
 * NOTICE OF LICENSE
 * 
 * This source file is subject to the Academic Free License (AFL 3.0)
 * 
 *  @author    Afternet <info@afternet.gr>
 *  @copyright 2019 Afternet
 *  @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */


import $ from 'jquery';

( function() {
    
    if( $('.js-whatWeDoLinks').length ){
        
        gsap.registerPlugin(ScrollTrigger);
        
//        gsap.to('.js-whatWeDoLinks', {
//            scrollTrigger: {
//                trigger: '.whatWeDo',
//                start: '-200px center',
//                end: 'bottom +400px',
//                markers: true,
//                scrub: 2.5,
//                //pin: true
//            },
//            yPercent: 60,
//            autoAlpha: 0,
//            duration: 3
//        });
        
        var sections = gsap.utils.toArray('.js-whatWeDoLink');
        sections.forEach((section) => {
  
            gsap.to(section, {
                scrollTrigger: {
                    trigger: section,
                    start: '-200px center',
                    end: '+=800px +=400px',
                    //markers: true,
                    scrub: 2.5,
                    //pin: true
                },
                yPercent: '+= 120',
                autoAlpha: 0,
                duration: 3
            });
        });
        
        
    }
    
} )();